import KContainer from './Container';
import KItem from './Item';

export default class KGrid {
  static Container = KContainer;

  static Item = KItem;
}
